import { Store } from 'react-notifications-component';
import { useCallback } from 'react';

/**
 * Hook used to handle notification.
 * @returns {{removeNotification: removeNotification, addNotification: (function({type: *, title?: *, message: *, insert?: *, container?: *, animationIn?: *,
 *     animationOut?: *, dismiss?: *}): string)}}
 */
export const useNotification = () => {
  const addNotification = useCallback(
    ({
      type,
      title,
      message,
      container = 'bottom-right',
      animationIn = ['animate__animated', 'animate__fadeIn'],
      animationOut = ['animate__animated', 'animate__fadeOut'],
      dismiss = {
        duration: 5000,
        pauseOnHover: true,
        onScreen: true,
        click: false,
        showIcon: true
      }
    }) => {
      if (type === 'error') {
        type = 'danger';
      }
      Store.addNotification({
        isMobile: true,
        type,
        title,
        message,
        container,
        animationIn,
        animationOut,
        dismiss
      });
    },
    []
  );

  const removeNotification = useCallback((id) => {
    Store.removeNotification(id);
  }, []);

  return { addNotification, removeNotification };
};
